import React from 'react'
import { withStyles } from '@material-ui/core'

import { styles } from './AttachmentUploadButtonStyles'
import { AttachmentIcon } from '../../../../icons/Icons'

const AttachmentUploadButton = props => {
  const { classes } = props

  return (
    <>
      <label className={classes.svgAttachmentHolder} htmlFor="attachment-files">
        <AttachmentIcon />
      </label>
    </>
  )
}

export default withStyles(styles)(AttachmentUploadButton)
